/* eslint-disable */
import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { useSelector } from 'react-redux';
import axios from 'axios';
import Select from 'react-select';
import config from '../../config/config';
import DashboardSection from '../DashboardContainer/DashboardSection';
import { usePopupManager } from "../../providers/PopupManager/PopupManager";
import { MESSAGE_TYPE } from "../../constants";
import DomainTile from '../DomainTile/DomainTile';
import ReusableTable from '../ReusableTable/ReusableTable';
// import styles from './DeatiledPageComp.module.css';
// import './DeatiledPageComp.css';
import "./P2PMainComp.css";
import styles from "./P2PMainComp.module.css";

const { API_BASE_URL } = config;

// const quarterOptions = [
//   { value: 'All', label: '(All)' },
//   { value: 'Q1', label: 'Q1' },
//   { value: 'Q2', label: 'Q2' },
//   { value: 'Q3', label: 'Q3' },
//   { value: 'Q4', label: 'Q4' },
// ];

const GLRconcilationDetail = () => {

  const token = useSelector((state) => state.auth.djangoAccessToken);
  const roles = useSelector((state) => state.auth.djangoRoles);
  const userInfo = useSelector((state) => state.auth.djangoUserInfo);

  const location = useLocation();
  const initialFilters = location.state || {
    entityData: null,
  };

  const { showPopup } = usePopupManager();
  const [showDashboard, setShowDashboard] = useState(false);
  const [isLoading, setIsLoading] = useState();
  
  const [hasApplied, setHasApplied] = useState(false);
  const [filters, setFilters] = useState(initialFilters);
  const [entityOptions, setEntityOptions] = useState([]);
  const [glAccOptions, setGlAccOptions] = useState([]);
  const [glTypeOptions, setGlTypeOptions] = useState([]);
  const [businessAreaOptions, setBusinessAreaOptions] = useState([]);
  const [ctlNameOptions, setCtlNameOptions] = useState([]);
  const [fullyProvisionOptions, setFullyProvisionOptions] = useState([]);
  const [yearOptions, setYearOptions] = useState([]);
  const [monthOptions, setMonthOptions] = useState([]);

  const [entity, setEntity] = useState(entityOptions[0]);
  const [glAcc, setGlAcc] = useState(glAccOptions[0]);
  const [glType, setGlType] = useState(glTypeOptions[0]);
  const [businessArea, setBusinessArea] = useState(businessAreaOptions[0]);
  const [ctlName, setCtlName] = useState(ctlNameOptions[0]);
  const [fullyProvision, setFullyProvision] = useState(ctlNameOptions[0]);
  const [year, setYear] = useState(yearOptions[0]);
  const [month, setMonth] = useState(monthOptions[0]);
//   const [quarter, setQuarter] = useState(quarterOptions[0]);
  const [totalRecords, setTotalRecords] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [page, setPage] = useState(1); 
  const itemsPerPage = 100;
  const [selectedPage, setSelectedPage] = useState();
  const [data, setData] = useState([]);
//   const [dataCSV, setDataCSV] = useState([]);

  const [startPage, setStartPage] = useState(0);
  const [endPage, setEndPage] = useState(100);

  
  const [dataLoading, setdataLoading] = useState(false);

  useEffect(() => {
    fetchData(filters);
  }, []);

  const fetchData = (filters) => {
    console.log("Fetching with", filters);
  };

  const customStyles = {
    control: (provided) => ({
      ...provided,
      minHeight: '20px',
      flexWrap: 'wrap',
    }),
    valueContainer: (provided) => ({
      ...provided,
      maxHeight: '50px',
      overflowY: 'auto',
    }),
    menu: (provided) => ({
      ...provided,
      zIndex: 9999,
      overflow: 'visible',
    }),
    menuList: (provided) => ({
      ...provided,
      maxHeight: '200px',
      overflowY: 'auto',
      overflowX: 'auto',
      whiteSpace: 'nowrap',
    }),
    option: (provided) => ({
      ...provided,
      padding: '8px 12px',
    }),
  };

//   const columns = [
//     // { header: "Sr. No.", accessor: "srNo" },
//     { header: "Entity", accessor: "entity" },
//     { header: "GL", accessor: "GL" },
//     { header: "GL Description", accessor: "GL_Description" },
//     { header: "Vendor Code", accessor: "vendor_code" },
//     { header: "Vendor Name", accessor: "vendor_name" },
//     { header: "CTL 1 Name", accessor: "CTL1_Name" },
//     { header: "Doc Type", accessor: "Doc_type" },
//     { header: "Doc Description", accessor: "Doc_Description" },
//     { header: "Timeline", accessor: "timeline" },
//     { header: "Remarks", accessor: "remarks" },
//     { header: "Provision Amt", accessor: "total_provision_amt" },
//     // { header: "Provision Comment", accessor: "trademark_comments" },
//     { header: "0-30 Days", accessor: "cnt_0_30_days" },
//     { header: "31-60 Days", accessor: "cnt_31_60_days" },
//     { header: "61-90 Days", accessor: "cnt_61_90_days" },
//     { header: "91-180 Days", accessor: "cnt_91_180_days" },
//     { header: "181-365 Days", accessor: "cnt_181_365_days" },
//     { header: "1-3 Years", accessor: "cnt_1_3_years" },
//     { header: ">3 Years", accessor: "cnt_above_3_years" },
//   ];

const columns = [
    { header: "Entity", accessor: "entity" },
    { header: "Vendor Code", accessor: "vendor_code" },
    { header: "Vendor Name", accessor: "vendor_name" },
    { header: "Invoice No", accessor: "invoice_no" },
    { header: "Sap Document No", accessor: "sap_document_no" },
    { header: "Fiscal Year", accessor: "fiscal_year" },
    { header: "Posting Date", accessor: "posting_date" },
    { header: "Document Type", accessor: "document_type" },
    { header: "Doc Description", accessor: "Doc_Description" },
    { header: "Business Area", accessor: "business_area" },
    { header: "Business Area Description", accessor: "business_area_desc" },
    { header: "Amount", accessor: "amount" },
    { header: "Amount in Crs", accessor: "amount_in_crs" },
    { header: "Text", accessor: "text" },
    { header: "Gl Account", accessor: "gl_account" },
    { header: "Gl Description", accessor: "gl_description" },
    { header: "Days", accessor: "days" },
    { header: "Aging", accessor: "aging" },
    { header: "Assignment", accessor: "assignment" },
    { header: "Purchasing Document", accessor: "purchasing_document" },
    { header: "Purchase Grp", accessor: "purchase_grp" },
    { header: "Purchase Grp Description", accessor: "purchase_grp_desc" },
    { header: "Purchase Org", accessor: "purchase_org" },
    { header: "Purchase Org Desc", accessor: "purchase_org_desc" },
    { header: "Commodity Name", accessor: "commodity_name" },
    { header: "Plant", accessor: "plant" },
    { header: "l3", accessor: "l3" },
    { header: "l2", accessor: "l2" },
    { header: "l1", accessor: "l1" },
    { header: "lc", accessor: "lc" },
    { header: "Reqname", accessor: "reqname" },
    { header: "Provision Amount", accessor: "provision_amount" },
    { header: "Fully Provided", accessor: "fully_provided" },
    { header: "Remarks", accessor: "remarks" },
    { header: "Timeline", accessor: "timeline" },
    { header: "Invoice Date", accessor: "invoice_date" },
    { header: "Net Due Date", accessor: "net_due_date" },
    { header: "Final Remarks", accessor: "final_remarks" },
    { header: "Plant Non Plant", accessor: "plant_non_plant" },
    { header: "Bg Validity Date", accessor: "bg_validity_date" },
    { header: "Bg Status Remark", accessor: "bg_status_remark" },
    { header: "Vendor Gl Type", accessor: "vendor_gl_type" },
    { header: "Gl Type of Advance", accessor: "gl_type_of_advance" },
    { header: "Document Header Text", accessor: "document_header_text" },
    { header: "Cost Center", accessor: "cost_center" },
    { header: "Scope", accessor: "scope" },
    { header: "Ap Remark", accessor: "ap_remark" },
    { header: "Current System Date", accessor: "Current_System_Date" },
    { header: "System Vc", accessor: "system_vc" },
    { header: "MSME Category", accessor: "msme_category" },
    { header: "MSME Nonmsme", accessor: "msme_nonmsme" },
    { header: "Bu Name", accessor: "bu_name" },
    { header: "V Code Block", accessor: "v_code_block" },
    { header: "Payt", accessor: "payt" },
    { header: "Pm", accessor: "pm" },
    { header: "Pbk", accessor: "pbk" },
    { header: "Payment Block", accessor: "payment_block" }
  ];
  
  const fetchEntityOptions = async () => {
    try {
      const response = await axios.get(`${API_BASE_URL}/api/P2P-gl-entity`, {
        headers: {
          // Authorization: `Bearer ${token}`,
          Authorization: 'Basic YWRtaW4xOjEyMw==',
        },
      })
      .then((response) => {
        setEntityOptions(response.data);
      })
    } catch (error) {
      console.error('Error fetching entity options:', error);
    }
  };

  const fetchGLAccountOptions = async () => {
    try {
      const response = await axios.get(`${API_BASE_URL}/api/P2P-gl-account`, {
        headers: {
          // Authorization: `Bearer ${token}`,
          Authorization: 'Basic YWRtaW4xOjEyMw==',
        },
      })
      .then((response) => {
        setGlAccOptions(response.data);
      })
    } catch (error) {
      console.error('Error fetching entity options:', error);
    }
  };

  // const fetchGLTypeOptions = async () => {
  //   const gl_acc_data = glAcc?.map((m) => m?.value) || [];
  //   try {
  //     const response = await axios.post(`${API_BASE_URL}/api/P2P-gl-type`,
  //     {
  //       selectedgltype: gl_acc_data,
  //     },
  //     {
  //       headers: {
  //         // Authorization: `Bearer ${token}`,
  //         Authorization: 'Basic YWRtaW4xOjEyMw==',
  //       },
  //     }
  //     )
  //     .then((response) => {
  //       setGlTypeOptions(response.data);
  //     })
  //   } catch (error) {
  //     console.error('Error fetching entity options:', error);
  //   }
  // };

  // const fetchGLBusinessAreaOptions = async () => {
  //   try {
  //     const response = await axios.get(`${API_BASE_URL}/api/P2P-gl-business-area`, {
  //       headers: {
  //         // Authorization: `Bearer ${token}`,
  //         Authorization: 'Basic YWRtaW4xOjEyMw==',
  //       },
  //     })
  //     .then((response) => {
  //       setBusinessAreaOptions(response.data);
  //     })
  //   } catch (error) {
  //     console.error('Error fetching entity options:', error);
  //   }
  // };

  const fetchGLCTL1Options = async () => {
    try {
      const response = await axios.get(`${API_BASE_URL}/api/P2P-gl-ctl1`, {
        headers: {
          // Authorization: `Bearer ${token}`,
          Authorization: 'Basic YWRtaW4xOjEyMw==',
        },
      })
      .then((response) => {
        setCtlNameOptions(response.data);
      })
    } catch (error) {
      console.error('Error fetching entity options:', error);
    }
  };

  const fetchGLFullyProvision = async () => {
    try {
      const response = await axios.get(`${API_BASE_URL}/api/P2P-gl-fully-provided`, {
        headers: {
          // Authorization: `Bearer ${token}`,
          Authorization: 'Basic YWRtaW4xOjEyMw==',
        },
      })
      .then((response) => {
        setFullyProvisionOptions(response.data);
      })
    } catch (error) {
      console.error('Error fetching entity options:', error);
    }
  };

  const fetchYearOptions = async () => {
    try {
      const response = await axios.get(`${API_BASE_URL}/api/P2P-gl-year`, {
        headers: {
          // Authorization: `Bearer ${token}`,
          Authorization: 'Basic YWRtaW4xOjEyMw==',
        },
      })
      .then((response) => {
        setYearOptions(response.data);
      })
    } catch (error) {
      console.error('Error fetching entity options:', error);
    }
  };

  const fetchMonthOptions = async () => {
    try {
      const response = await axios.get(`${API_BASE_URL}/api/P2P-gl-month`, {
        headers: {
          // Authorization: `Bearer ${token}`,
          Authorization: 'Basic YWRtaW4xOjEyMw==',
        },
      })
      .then((response) => {
        setMonthOptions(response.data);
      })
    } catch (error) {
      console.error('Error fetching entity options:', error);
    }
  };

  const handleEntityChange = (selected) => {
    setEntity(selected);
    setFilters(prev => ({ ...prev, entityData: selected }));
  };

  const handleGLAccountChange = (selected) => {
    setGlAcc(selected);
    // setFilters(prev => ({ ...prev, geographyData: selected }));
    try {
      const response = axios.post(`${API_BASE_URL}/api/P2P-gl-type`,
      {
        selectedglacc: selected?.map((m) => m?.value) || [],
      },
      {
        headers: {
          // Authorization: `Bearer ${token}`,
          Authorization: 'Basic YWRtaW4xOjEyMw==',
        },
      }
      )
      .then((response) => {
        setGlTypeOptions(response.data);
      })
    } catch (error) {
      console.error('Error fetching entity options:', error);
    }
  };

  const handleGLTypeChange = (selected) => {
    setGlType(selected);
    // setFilters(prev => ({ ...prev, geographyData: selected }));
  };

  const handleBusinessChange = (selected) => {
    setBusinessArea(selected);
    // setFilters(prev => ({ ...prev, geographyData: selected }));
  };

  const handleCTLNameChange = (selected) => {
    setCtlName(selected);
    // setFilters(prev => ({ ...prev, geographyData: selected }));
  };

  const handleFullyProvisionChange = (selected) => {
    setFullyProvision(selected);
    // setFilters(prev => ({ ...prev, geographyData: selected }));
  };

  const handleYearChange = (selected) => {
    setYear(selected);
    // setFilters(prev => ({ ...prev, yearData: selected }));
  };

  const handleMonthChange = (selected) => {
    setMonth(selected);
    // setFilters(prev => ({ ...prev, monthData: selected }));
  };

  const handleApply = () => {
    const entity_data = entity?.map((m) => m?.value) || [];
    // const gl_acc_data = glAcc?.value ?? [];
    const gl_acc_data = glAcc?.map((m) => m?.value) || [];
    const gl_type_data = glType?.map((m) => m?.value) || [];
    const business_area_data = businessArea?.map((m) => m?.value) || [];
    // const ctl1_data = ctlName.value || [];
    const ctl1_data = ctlName?.map((m) => m?.value) || [];
    const fullyProvision_data = fullyProvision?.map((m) => m?.value) || [];
    const year_data = year?.map((m) => m?.value) || [];
    const month_data = month?.map((m) => m?.value) || [];
    const page = selectedPage || 1;
    const limit = itemsPerPage;
    const offset = (page - 1) * limit;

    if (entity_data && entity_data.length === 0) {
        showPopup({
          type: MESSAGE_TYPE.INFORMATION,
          contextText: MESSAGE_TYPE.INFORMATION,
          info: "Please select entity.",
        });
        return;
      }

    // setIsLoading(true);
    const fetchTreadmarkData = async () => {
    setIsLoading(true);
      try {
        const response = await axios.post(`${API_BASE_URL}/api/GL-reconcilation-DetailedView`,
          {
            selectedentity: entity_data,
            selectedglacc: gl_acc_data,
            selectedgltype: gl_type_data,
            selectedbusinessarea: business_area_data,
            selectedctl1: ctl1_data,
            selectedfullyprovision: fullyProvision_data,
            selectedyear: year_data,
            selectedmonth: month_data,
            start: startPage,
            end: endPage,
          },
          {
            headers: {
              Authorization: 'Basic YWRtaW4xOjEyMw==',
            },
          }
        );


        setShowDashboard(true);
        setData(response.data.data)
        setTotalRecords(response.data.total_count)
        // setDataCSV(response.data.dataCSV);
      } catch (error) {
        console.error('Error fetching trademark data:', error);
      } finally {
        setdataLoading(false);
        setIsLoading(false);
      }
    };

    fetchTreadmarkData();
  };

//   const handleCSVDownload = () => {
//     const totalColumns = [
//       'total_provision_amt',
//       'cnt_0_30_days',
//       'cnt_31_60_days',
//       'cnt_61_90_days',
//       'cnt_91_180_days',
//       'cnt_181_365_days',
//       'cnt_1_3_years',
//       'cnt_above_3_years'
//     ];
  
//     // CSV Header
//     const csvHeader = columns.map(col => col.header).join(',');
  
//     // Data rows
//     const csvRows = dataCSV.map(row =>
//       columns
//         .map(col =>
//           `"${String(row[col.accessor] ?? '').replace(/"/g, '""')}"`
//         )
//         .join(',')
//     );
  
//     // ---- TOTAL row calculation ----
//     const totals = {};
//     totalColumns.forEach(col => {
//       totals[col] = dataCSV.reduce(
//         (sum, row) => sum + Number(row[col] || 0),
//         0
//       );
//     });
  
//     const totalRow = columns
//       .map((col, index) => {
//         if (index === 0) return `"TOTAL"`; // first column label
//         if (totalColumns.includes(col.accessor)) {
//           return `"${totals[col.accessor]}"`;
//         }
//         return `""`;
//       })
//       .join(',');
  
//     // Final CSV
//     const csvContent = [csvHeader, ...csvRows, totalRow].join('\n');
  
//     const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
//     const link = document.createElement('a');
//     link.href = URL.createObjectURL(blob);
//     link.download = 'Vendor_GL_Ageing_Report.csv';
//     link.click();
//   };
  
const downloadCSV = () => {
    try {
      if (!data || !data.length) return;
  
      const headers = Object.keys(data[0]);
  
      const csvRows = [
        headers.join(","), // header row
        ...data.map(row =>
          headers.map(
            key => row[key] !== null ? `"${row[key]}"` : ""
          ).join(",")
        )
      ];
  
      const csvContent = csvRows.join("\n");
  
      const blob = new Blob([csvContent], {
        type: "text/csv;charset=utf-8;",
      });
  
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = url;
      link.download = "vendor_GL_Details_report.csv";
  
      document.body.appendChild(link);
      link.click();
      link.remove();
      window.URL.revokeObjectURL(url);
  
    } catch (error) {
      console.error("CSV Download Error:", error);
    }
  };

  const handleReset = () => {
    setShowDashboard(false);
    setHasApplied(false);
  
    setEntity([]);
    setGlAcc([]);
    setGlType([]);
    setBusinessArea([]);
    setCtlName([]);
    setYear([]);
    setMonth([]);
  
    setSelectedPage(1);
    setStartPage(0);
    setEndPage(100);
  
    setData([]);
    // setDataCSV([]);
    setTotalRecords(0);
  };

  useEffect(() => {
    fetchEntityOptions();
    fetchGLAccountOptions();   
    fetchGLCTL1Options();    
    fetchGLFullyProvision();    
    fetchYearOptions();
    fetchMonthOptions();
  }, []);

const handlePageChange = (page) => {
    setHasApplied(true)
    setSelectedPage(page);
    let endPageVal = page * 100
    let startPageVal = endPageVal - 99

    setStartPage(startPageVal)
    setEndPage(endPageVal)
    // console.log(`Selected page: ${page}`);

  };

  useEffect(() => {
    if (hasApplied) {
      handleApply();
    }
  }, [selectedPage,hasApplied]);

  useEffect(() => {
    if (glTypeOptions && glTypeOptions.length > 0) {
      setGlType(glTypeOptions); // ✅ auto select all
      try {
        const response = axios.post(`${API_BASE_URL}/api/P2P-gl-business-area`,
          {
            selectedgltype: glTypeOptions?.map((m) => m?.value) || [],
          },{
          headers: {
            // Authorization: `Bearer ${token}`,
            Authorization: 'Basic YWRtaW4xOjEyMw==',
          },}
        )
        .then((response) => {
          setBusinessAreaOptions(response.data);
        })
      } catch (error) {
        console.error('Error fetching entity options:', error);
      }
    } else {
      setGlType([]); // reset if empty
    }
  }, [glTypeOptions]);

  useEffect(() => {
    if (businessAreaOptions && businessAreaOptions.length > 0) {
      setBusinessArea(businessAreaOptions); // ✅ auto select all
    } else {
      setBusinessArea([]); // reset if empty
    }
  }, [businessAreaOptions])

  useEffect(() => {
    if (
      entityOptions.length 
    ) {
      let shouldApply = false;

      if (filters.entityData) {
        const ent = entityOptions.find(
          (opt) => opt.value === filters.entityData?.map((m) => m?.value) || []
        );
        if (ent) {
          setEntity(filters.entityData);
          shouldApply = true;
        }
      }

      if (shouldApply) {
        console.log(shouldApply)
        setHasApplied(true);
      }
    }
  }, [entityOptions]);
  

  return (
    <>
      <div className={styles.filter_panel_container}>
        <div className={styles.filter_panel_row}>
          <div className={styles.filter_panel_col}>
            <label className={styles.filter_label}>Entity
            <span style={{ color: "red" }}>*</span></label>
            <div className={styles.filter_select_wrapper}>
              <Select
                value={entity}
                isMulti={true}
                closeMenuOnSelect={false}
                // onChange={setEntity}
                onChange={handleEntityChange}
                options={entityOptions}
                isSearchable={false}
                styles={customStyles}
              />
            </div>
          </div>
          <div className={styles.filter_panel_col}>
            <label className={styles.filter_label}>GL Account</label>
            <div className={styles.filter_select_wrapper}>
              <Select
                value={glAcc}
                isMulti={true}
                closeMenuOnSelect={false}
                // onChange={setGeography}
                onChange={handleGLAccountChange}
                options={glAccOptions}
                isSearchable={false}
                styles={customStyles}
              />
            </div>
          </div>
          <div className={styles.filter_panel_col}>
            <label className={styles.filter_label}>GL Type</label>
            <div className={styles.filter_select_wrapper}>
              <Select
                value={glType}
                isMulti={true}
                closeMenuOnSelect={false}
                // onChange={setGeography}
                onChange={handleGLTypeChange}
                options={glTypeOptions}
                isSearchable={false}
                styles={customStyles}
              />
            </div>
          </div>
          <div className={styles.filter_panel_col}>
            <label className={styles.filter_label}>Business Area</label>
            <div className={styles.filter_select_wrapper}>
              <Select
                value={businessArea}
                isMulti={true}
                closeMenuOnSelect={false}
                // onChange={setGeography}
                onChange={handleBusinessChange}
                options={businessAreaOptions}
                isSearchable={false}
                styles={customStyles}
              />
            </div>
          </div>

        </div>
        <div className={`${styles.filter_panel_row} mt-2`}>
        <div className={styles.filter_panel_col}>
            <label className={styles.filter_label}>CTL 1 Name</label>
            <div className={styles.filter_select_wrapper}>
              <Select
                value={ctlName}
                isMulti={true}
                closeMenuOnSelect={false}
                // onChange={setGeography}
                onChange={handleCTLNameChange}
                options={ctlNameOptions}
                isSearchable={false}
                styles={customStyles}
              />
            </div>
          </div>
          <div className={styles.filter_panel_col}>
            <label className={styles.filter_label}>Fully Provision</label>
            <div className={styles.filter_select_wrapper}>
              <Select
                value={fullyProvision}
                isMulti={true}
                closeMenuOnSelect={false}
                // onChange={setYear}
                onChange={handleFullyProvisionChange}
                options={fullyProvisionOptions}
                isSearchable={false}
                styles={customStyles}
              />
            </div>
          </div>
          <div className={styles.filter_panel_col}>
          <label className={styles.filter_label}>Year</label>
            <div className={styles.filter_select_wrapper}>
              <Select
                value={year}
                isMulti={true}
                closeMenuOnSelect={false}
                // onChange={setYear}
                onChange={handleYearChange}
                options={yearOptions}
                isSearchable={false}
                styles={customStyles}
              />
            </div>
          </div>
          <div className={styles.filter_panel_col}>
            <label className={styles.filter_label}>Month</label>
            <div className={styles.filter_select_wrapper}>
              <Select
                value={month}
                isMulti={true}
                // onChange={setMonth}
                onChange={handleMonthChange}
                closeMenuOnSelect={false}
                options={monthOptions}
                isSearchable={false}
                styles={customStyles}
              />
            </div>
          </div>
        </div>
        <div className={`${styles.filter_panel_row}`}>
          <div className={styles.filter_panel_col}>
                      <div className="filter-panel-col action-buttons">
            <button onClick={handleApply} className="btn apply-btn">
              Apply
            </button>
            <button onClick={handleReset} className="btn reset-btn">
              Reset
            </button>
          </div>
          </div>
        </div>
      </div>

      {isLoading && (
        <div
          style={{
            position: 'fixed',
            top: 0,
            left: 0,
            width: '100vw',
            height: '100vh',
            backgroundColor: 'rgba(255, 255, 255, 0.8)',
            zIndex: 9999,
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            alignItems: 'center',
          }}
        >
          <div className="text-center">
            <div className="spinner-border text-primary mb-3" role="status"></div>
            <p className="mb-3" style={{ fontSize: "18px", fontWeight: "bold", color: "#0067ac" }}>Loading...</p>
            
          </div>
        </div>
      )}
      
{showDashboard && (

      <div>
        <div className="row">
          <div className="col-md-12">
          <DomainTile title='Vendor GL Ageing Detailed Report' showBackButton={true} mainPagePath="/GL-Reconciliation" detailState = {filters}/>
          </div>
        </div>
        <div className="row">
          <div className="col-md-12">
            <DashboardSection title="" disableDetailView={true}>
              {/* <h2> tabel here</h2> */}
              <ReusableTable
                  data={data} columns={columns} itemsPerPage={itemsPerPage} onPageChange={handlePageChange} isCustomOpen={true} totalRecords={totalRecords} handleCSVDownload={downloadCSV} dataLoading={dataLoading}
                />
            </DashboardSection>
          </div>
        </div>
      </div>
      )}
    </>
  );
};

export default GLRconcilationDetail;